export default "__VITE_ASSET__CDIljIZ$__"